import BaseAPI from '../baseApi';
import { Product, ProductSearchParams } from '../interfaces';
import { denormalize } from 'normalizr';
import { productSchema } from '../entities/entities';

export class ProductApi extends BaseAPI {
  model = 'retailers';
  prefix = 'api/v3';

  async getProducts(ids: string[], params: ProductSearchParams): Promise<Product[]> {
    const json = await this.post<any>('multi_select', { ids, ...params });

    if (json?.entities?.products) {
      Object.keys(json.entities.products).forEach((key) => {
        json.entities.products[key].id = key;
      });
    }

    return denormalize(json, { products: [productSchema] }, json.entities).products;
  }

  protected async body(
    params: ProductSearchParams,
  ): Promise<ProductSearchParams & { clientId: string }> {
    return { ...params, clientId: this.getClientId() };
  }

  protected async headers(): Promise<Record<string, string>> {
    return { 'X-Header-Convention': 'camel' };
  }
}
